// PostHog product analytics for app.clipbait.ai (same project as clipbait.ai,
// so a visitor's marketing-site clicks and in-app funnel join up).
// The project API key is public by design. Paste it below (PostHog → Settings
// → Project → Project API key) or set REACT_APP_POSTHOG_KEY at build time.
// While empty, nothing loads and every call here is a no-op.
import posthog from "posthog-js";

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY || "phc_rj6hv5r9VFqxNTxEsWNpXmjMMp8g6ivFAWLYY4fGhWBA";
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";

let started = false;

// The admin account is never tracked or recorded: its screens show other
// users' emails and data, and its activity would skew the numbers.
const ADMIN_EMAIL = "clipbaitla@gmail.com";
export const isAdminUser = (user) =>
  !!user?.isAdmin || String(user?.email || "").toLowerCase() === ADMIN_EMAIL;

// Login links carry the session token (/auth-success?token=…). Blank it out of
// everything sent to PostHog (URLs, referrers, replay snapshots) so nobody with
// PostHog access can sign in as a user.
const SECRET_PARAM = /([?&#](?:token|access_token|id_token|code)=)[^&#"\s]*/gi;
function scrub(v, depth = 0) {
  if (typeof v === "string") return v.includes("=") ? v.replace(SECRET_PARAM, "$1[redacted]") : v;
  if (!v || typeof v !== "object" || depth > 12) return v;
  if (Array.isArray(v)) {
    for (let i = 0; i < v.length; i++) v[i] = scrub(v[i], depth + 1);
    return v;
  }
  for (const k of Object.keys(v)) v[k] = scrub(v[k], depth + 1);
  return v;
}

export function initAnalytics() {
  if (!POSTHOG_KEY || started) return;
  started = true;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    cross_subdomain_cookie: true,
    capture_pageview: "history_change", // SPA route changes count as pageviews
    capture_pageleave: true,
    person_profiles: "identified_only",
    // Session replay (turn on in PostHog → Settings → Session replay).
    // Anything typed into inputs is masked in recordings.
    session_recording: { maskAllInputs: true },
    before_send: (event) => {
      if (!event) return event;
      scrub(event.properties);
      scrub(event.$set);
      scrub(event.$set_once);
      return event;
    },
  });
  // A returning admin (already logged in) never gets recorded either.
  try {
    if (isAdminUser(JSON.parse(localStorage.getItem("user") || "null"))) posthog.opt_out_capturing();
  } catch { /* ignore */ }
}

/** Tie events to the logged-in user (matches the marketing site's identify). */
export function identifyUser(user) {
  if (!started || !user?._id) return;
  try {
    if (isAdminUser(user)) {
      posthog.opt_out_capturing(); // stops events + session recording
      return;
    }
    if (posthog.has_opted_out_capturing?.()) posthog.opt_in_capturing();
    posthog.identify(String(user._id), { email: user.email, username: user.username });
  } catch { /* never break the app */ }
}

export function track(event, properties) {
  if (!started) return;
  try {
    posthog.capture(event, properties);
  } catch { /* never break the app */ }
}

export function resetAnalytics() {
  if (!started) return;
  try { posthog.reset(); } catch { /* ignore */ }
}
